module.exports = __webpack_public_path__ + "img/automatedLab.297c2324.jpeg";